module.exports = __webpack_public_path__ + "media/components/src/assets/images/block_image_2-12ce0aa787e4cafe058a08109edb303c.jpg";